export interface IKeyValuePair {
    key: number,
    value: string
}